import React from 'react';

const teamMembers = [
  { initials: 'DS', name: 'Dan Smith',      role: 'CEO & Founder',     dept: 'Executive',   bg: 'bg-blue-dark'  },
  { initials: 'AJ', name: 'Alex Johnson',   role: 'VP of Operations',  dept: 'Operations',  bg: 'bg-username'   },
  { initials: 'SM', name: 'Sarah Mitchell', role: 'Head of Marketing', dept: 'Marketing',   bg: 'bg-instagram'  },
  { initials: 'RK', name: 'Ryan Kim',       role: 'Lead Engineer',     dept: 'Engineering', bg: 'bg-green'      },
  { initials: 'TP', name: 'Tanya Patel',    role: 'Product Manager',   dept: 'Product',     bg: 'bg-safforn'    },
  { initials: 'NL', name: 'Noah Lewis',     role: 'Sales Director',    dept: 'Sales',       bg: 'bg-voilet'     },
  { initials: 'DW', name: 'Diana Wong',     role: 'Finance Manager',   dept: 'Finance',     bg: 'bg-lred'       },
  { initials: 'CG', name: 'Carlos Garcia',  role: 'UX Designer',       dept: 'Product',     bg: 'bg-lblue'      },
];

const SectionCard = ({ children, extraClass = '' }) => (
  <div className={`bg-white brd-10 shadow-small p-20 m-b-20 ${extraClass}`}>{children}</div>
);

const CardHeader = ({ title, action, onAction }) => (
  <div className="flex justspacebetween aligncenter m-b-15">
    <span className="fw700 font-15 color-black">{title}</span>
    {action && <span className="font-12 highlight pointer fw500" onClick={onAction}>{action}</span>}
  </div>
);

const TeamTab = () => {
  return (
    <SectionCard>
      <CardHeader title="Team Members" action="Add Member" />
      <div className="grid-4col gap-15">
        {teamMembers.map((m, i) => (
          <div key={i} className="text-center p-15 br-grey brd-10">
            <div className={`circle-avatar-md flex aligncenter justifycenter fw700 font-18 text-white mx-auto m-b-10 ${m.bg}`}>{m.initials}</div>
            <div className="font-13 fw500 dark-navy">{m.name}</div>
            <div className="font-11 lgrey m-t-2">{m.role}</div>
            <span className="badge-3 bg-blue-white color-highlight m-t-6 d-inline-block">{m.dept}</span>
          </div>
        ))}
      </div>
    </SectionCard>
  );
};

export default TeamTab;